export const paymentInitialState = {
    paymentResult: "",
    errors: {},
    paymentResponse: {},
    pmtResult: false,
}

export const AsyncPaymentHandlers = {

};

export const PaymentReducer = (state, action) => {
    if (action.type === 'PAYMENT_CARD_VALIDATION_ERROR') {
        let { errors } = action.payload;
        return {
            ...state,
            pmtResult: false,
            errors: errors,
            paymentResult: 'PAYMENT_FAILED'
        }
    } else if (action.type === 'PAYMENT_VALIDATION_ERROR') {
        let { errors } = action.payload;
        return {
            ...state,
            pmtResult: false,
            errors: errors,
            paymentResult: 'PAYMENT_FAILED'
        }
    } else  if (action.type === 'PAYMENT_CANCELLED') {
        let { errors } = action.payload;
        return {
            ...state,
            pmtResult: false,
            paymentResult: 'PAYMENT_CANCELLED',
            errors: errors
        }
    } else if (action.type === 'PAYMENT_ERROR') {
        let { errors } = action.payload;
        return {
            ...state,
            pmtResult: false,
            paymentResult: 'PAYMENT_FAILED',
            errors: errors,
        }
    } else if (action.type === 'PAYMENT_DECLINED') {
        let { errors } = action.payload;
        return {
            ...state,
            pmtResult: false,
            paymentResult: 'PAYMENT_DECLINED',
            errors: errors
        }
    } else if (action.type === 'PAYMENT_SUCCEEDED') {
        let { paymentResponse } = action.payload;
        return {
            ...state,
            pmtResult: true,
            paymentResult: 'PAYMENT_SUCCEEDED',
            paymentResponse: paymentResponse,
        }
    } else if (action.type === 'PAYMENT_PENDING_APPROVAL') {
        let { paymentResponse } = action.payload;
        return {
            ...state,
            pmtResult: true,
            paymentResult: 'PAYMENT_PENDING_APPROVAL',
            paymentResponse: paymentResponse,
        }
    } else if (action.type === 'PAYMENT_PROCESSING') {
        let { paymentResponse } = action.payload;
        return {
            ...state,
            pmtResult: true,
            paymentResult: 'PAYMENT_PROCESSING',
            paymentResponse: paymentResponse,
        }
    } 
    else if (action.type === 'PAYMENT_WORKING') {
        return {
            ...state,
            paymentResult: 'PAYMENT_WORKING',
            errors: {}
        }
    }
    else if (action.type === 'PAYMENT_WORKING_SECONDARY') {
        let { errors } = action.payload;
        return {
            ...state,
            paymentResult: 'PAYMENT_WORKING_SECONDARY',
            errors: errors
        }
    }
    else if (action.type === 'RESET_MESSAGE_AND_ERRORS') {
        return {
            ...state,
            errors: {}
        }
    }
    else {
        return {
            ...state
        }
    }
}
